import React from 'react';
import useGetRequest from 'src/hooks/useGetRequest';
import { Widget } from 'src/types';
import SlateRichTextArea, { VARIABLE_TYPE } from 'src/components/slate/SlateRichTextArea';
import Label from 'src/components/Label';

interface Props {
  widget: Widget,
  engagementId: string,
  editMode?: boolean,
}

const RichTextRenderer = ({
  widget,
  engagementId,
  editMode
}: Props) => {
  const { text } = widget.data;
  const payload = text ? JSON.parse(text) : [];
  const hasVariables = payload.some((slice: any) => slice.children.some((child: any) => child.type === VARIABLE_TYPE));

  const requiresInterpolation = !editMode && hasVariables;

  // interpolation can happen on the backend or on the frontend
  const { result, isLoading } = useGetRequest({
    url: `/automatic/engagements/${engagementId}/interpolate-text/`,
    methodOverride: 'post',
    payload,
    shouldFetchOnInitialRender: Boolean(requiresInterpolation),
    shouldCamelCaseResponse: false,
  });

  if (isLoading) return null;

  // interpolation failed
  if (!isLoading && !result && requiresInterpolation) return <Label color="error">Something went wrong.</Label>;

  return (
    <SlateRichTextArea
      value={result ? JSON.stringify(result) : text}
      readOnly
    />
  );
};

export default RichTextRenderer;
